/**
 * On-screen controls guide. Shows automatically on game start,
 * auto-hides after a while, and toggles with F1 at any time.
 * Skipped on touch devices (they have their own visible buttons).
 */

const AUTO_HIDE_MS = 25000;

const CONTROLS: Array<[key: string, action: string]> = [
  ["WASD", "mover"],
  ["Espaço", "pular"],
  ["Shift / 2×W", "correr"],
  ["Mouse", "olhar"],
  ["Clique esq.", "quebrar / atacar"],
  ["Clique dir.", "colocar / comer / usar cama, mesa e baú"],
  ["Q", "largar item da mão"],
  ["J", "painel de missões"],
  ["F5", "câmera (3ª pessoa)"],
  ["E", "inventário & crafting"],
  ["Enter", "chat"],
  ["1-4", "poderes"],
  ["5-9 / scroll", "hotbar"],
  ["2× Espaço", "voar (modo criativo)"],
  ["F1", "mostrar/ocultar ajuda"],
];

export type ControlsHint = {
  dispose: () => void;
};

export function createControlsHint(): ControlsHint {
  const panel = document.createElement("div");
  panel.id = "controls-hint";
  panel.style.cssText = `
    position: absolute;
    bottom: 16px;
    right: 12px;
    padding: 10px 14px;
    background: rgba(0, 0, 0, 0.55);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    font-size: 11px;
    line-height: 1.6;
    color: #ddd;
    pointer-events: none;
    transition: opacity 0.6s;
    max-width: 240px;
  `;

  const title = document.createElement("div");
  title.textContent = "Controles";
  title.style.cssText = `font-weight: 700; color: #4ade80; margin-bottom: 4px; font-size: 12px;`;
  panel.appendChild(title);

  for (const [key, action] of CONTROLS) {
    const row = document.createElement("div");
    const keyEl = document.createElement("span");
    keyEl.textContent = key;
    keyEl.style.cssText = `
      display: inline-block;
      min-width: 86px;
      color: #fff;
      font-family: monospace;
      font-weight: 600;
    `;
    row.appendChild(keyEl);
    row.appendChild(document.createTextNode(action));
    panel.appendChild(row);
  }

  const overlay = document.getElementById("ui-overlay");
  (overlay ?? document.body).appendChild(panel);

  let visible = true;
  let autoHideTimer: ReturnType<typeof setTimeout> | null = setTimeout(() => hide(), AUTO_HIDE_MS);

  function show() {
    visible = true;
    panel.style.opacity = "1";
  }

  function hide() {
    visible = false;
    panel.style.opacity = "0";
  }

  function handleKeyDown(e: KeyboardEvent) {
    if (e.code === "F1") {
      e.preventDefault(); // don't open the browser help
      if (autoHideTimer) {
        clearTimeout(autoHideTimer);
        autoHideTimer = null;
      }
      if (visible) hide();
      else show();
    }
  }
  document.addEventListener("keydown", handleKeyDown);

  return {
    dispose() {
      if (autoHideTimer) clearTimeout(autoHideTimer);
      document.removeEventListener("keydown", handleKeyDown);
      panel.remove();
    },
  };
}
